export default "__VITE_ASSET__8$gWvsXL__"